import { getRuntimeConfig } from '../../lib/runtimeConfig';
import { buildCurrentUserUrl } from '../../helpers/urls';

/* istanbul ignore next */
const publicRuntimeConfig = getRuntimeConfig() || {};

export default async function isLoggedIn() {
  if (publicRuntimeConfig.mockUserLoggedIn && !publicRuntimeConfig.isProd) {
    return 1;
  }
  const url = buildCurrentUserUrl();
  if (!url) {
    return null;
  }
  const result = await fetch(url, {
    credentials: 'include',
    mode: 'cors',
  });
  if (result.ok) {
    const json = await result.json();
    return json?.id;
  }
  return null;
}
